import React from 'react';
 
/**
 * Reusable form select component
 * @param {Object} props
 * @param {string} props.id - Select id
 * @param {string} props.name - Select name
 * @param {string} props.label - Label text
 * @param {string} props.value - Selected value
 * @param {Function} props.onChange - Change handler
 * @param {Array} props.options - Array of options {value, label} or string array
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.error - Error message
 * @param {boolean} props.required - Whether field is required
 * @param {boolean} props.disabled - Whether select is disabled
 * @param {Object} props.otherProps - Other select props
 */
const FormSelect = ({
  id,
  name,
  label,
  value,
  onChange,
  options = [],
  placeholder = 'Select a option',
  error,
  required = false,
  disabled = false,
  ...otherProps
}) => {
  return (
    <div className="form-row">
      {label && (
        <label className="label-one m-0" htmlFor={id}>
          {label}
           {required && <span style={{ color: '#dc2626' }}> *</span>}
        </label>
      )}
      <select
        id={id}
        name={name}
        className={`form-input ${error ? 'has-error' : ''}`}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...otherProps}
      >
        <option value="">{placeholder}</option>
        {options.map((option, index) => {
          const optionValue = typeof option === 'string' ? option : option.value;
          const optionLabel = typeof option === 'string' ? option : option.label;
          const optionKey = typeof option === 'object' && option.key ? option.key : index;
         
          return (
            <option key={optionKey} value={optionValue}>
              {optionLabel}
            </option>
          );
        })}
      </select>
      {error && <div className="error-text">{error}</div>}
    </div>
  );
};
 
export default FormSelect; 